/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FirmwareType,
    FirmwareTypeFromJSON,
    FirmwareTypeFromJSONTyped,
    FirmwareTypeToJSON,
} from './FirmwareType';

/**
 * 
 * @export
 * @interface RescueByDeviceTypeResponse
 */
export interface RescueByDeviceTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof RescueByDeviceTypeResponse
     */
    packageName?: string;
    /**
     * 
     * @type {FirmwareType}
     * @memberof RescueByDeviceTypeResponse
     */
    type?: FirmwareType;
    /**
     * 
     * @type {string}
     * @memberof RescueByDeviceTypeResponse
     */
    version?: string;
}

export function RescueByDeviceTypeResponseFromJSON(json: any): RescueByDeviceTypeResponse {
    return RescueByDeviceTypeResponseFromJSONTyped(json, false);
}

export function RescueByDeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RescueByDeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'packageName': !exists(json, 'packageName') ? undefined : json['packageName'],
        'type': !exists(json, 'type') ? undefined : FirmwareTypeFromJSON(json['type']),
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function RescueByDeviceTypeResponseToJSON(value?: RescueByDeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'packageName': value.packageName,
        'type': FirmwareTypeToJSON(value.type),
        'version': value.version,
    };
}

